import './App.less';

import 'i18n/config';

import { ConfigProvider } from 'antd';
import { useLocale, useUser } from 'hooks';
import { Prompt, BrowserRouter as ReactRouter, useLocation } from 'react-router-dom';

import { useMemoizedFn, useMount } from 'ahooks';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import CanvaSsoExchangeBootstrap from 'features/Login/components/CanvaSsoExchangeBootstrap';
import { AppLayout } from './Layout';
import Router from './Router';
import { useAppDispatch, useAppSelector } from './hooks';
import {
  getCanvaExchangeCode,
  isCanvaSsoExchangePending,
} from 'utils/canvaSso';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
// TODO: this should be injected from build process
const STRIPE_PK =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
  'pk_test_51SCzEnCMHyv1HibDNPhP16BOxryf6xC85hEAZ1B1LyzcOn0oE71BTWPIHQxh9Jtnk6Pq4xw9NUu4ysHzkOsCwvic00AFYxoZlq';

console.log(
  'REACT_APP_STRIPE_PUBLIC_KEY',
  process.env.REACT_APP_STRIPE_PUBLIC_KEY
);
console.log('STRIPE_PK', STRIPE_PK);
const stripePromise = loadStripe(STRIPE_PK);

moment.tz.setDefault();

export function AppShell() {
  const { locale } = useLocale();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const loading = useAppSelector((state) => state.app.loading);
  const isUploading = useAppSelector((state) => state.app.isUploading);
  const user = useUser();
  const { t } = useTranslation();
  const canvaSsoPending = isCanvaSsoExchangePending(location.search);

  const onClickChecker = useMemoizedFn((e) => {
    if (isUploading) {
      if (e.type === 'beforeunload') {
        e.preventDefault();
        e.returnValue = t('common.leaveConfirmQuestion');
        return;
      }

      const target =
        e.target.closest('.workspace-filter-tabs-item') ||
        e.target.closest('.logout-item') ||
        e.target.closest('.round-toggle-btn') ||
        e.target.closest('.workspace-item-close');
      if (!target) {
        return;
      }
      const isOk = window.confirm(t('common.leaveConfirmQuestion'));

      if (!isOk) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        dispatch.app.setState({
          isUploading: false,
        });
      }
    }
  });

  const hideGlobalLoading = async () => {
    await dispatch.app.hideLoading();
  };

  /**
   * Here we init the global states
   */
  useMount(async () => {
    dispatch.app.switchTheme('default');
    const pendingCanvaExchange = Boolean(
      getCanvaExchangeCode(window.location.search)
    );
    if (user && !pendingCanvaExchange) {
      await dispatch.app.hydrateAuthenticatedSession(user);
    }

    window.addEventListener('click', onClickChecker, { capture: true });
    window.addEventListener('beforeunload', onClickChecker);

    window.addEventListener('unhandledrejection', hideGlobalLoading);

    return () => {
      window.removeEventListener('click', onClickChecker);
      window.removeEventListener('beforeunload', onClickChecker);
      window.removeEventListener('unhandledrejection', hideGlobalLoading);
    };
  });

  return (
    <>
      <CanvaSsoExchangeBootstrap />
      <ConfigProvider locale={locale}>
        <Elements
          stripe={stripePromise}
          options={{ mode: 'setup', currency: 'usd' }}
        >
          <AppLayout loading={loading || canvaSsoPending}>
            {!canvaSsoPending && <Router />}
          </AppLayout>
        </Elements>
      </ConfigProvider>
      <Prompt when={isUploading} message={t('common.leaveConfirmQuestion')} />
    </>
  );
}

function App() {
  return (
    <ReactRouter>
      <AppShell />
    </ReactRouter>
  );
}

export default App;
